import { useNavigate } from 'react-router';
import { Row, Text } from '~/commonComponents';
import { useAppSelector } from '~/hooks';
import { fireDashboardContinueDraftClicked } from '~/posthogs/events';
import { Colors } from '~/themes/colors';

export const DraftPrompt = () => {
  const navigate = useNavigate();
  const draftCount = useAppSelector((state) => state.permanentJobs.draftCount);

  if (!draftCount || draftCount <= 0) return null;

  const countLabel =
    draftCount === 1
      ? '1 draft in progress'
      : `${draftCount} drafts in progress`;

  const handleContinueEditing = () => {
    fireDashboardContinueDraftClicked();
    navigate('/permanent-jobs/postings?status=draft');
  };

  return (
    <Row
      alignItems="center"
      justifyContent="center"
      gap={4}
      backgroundColor="rgba(48, 127, 146, 0.25)"
      paddingVertical={10}
      data-testid="draft-prompt"
    >
      <Text color={Colors.white} fontSize={14}>
        {countLabel} -
      </Text>
      <Text
        bold
        color={Colors.white}
        fontSize={14}
        cursor="pointer"
        role="link"
        textDecoration="underline"
        onClick={handleContinueEditing}
        data-testid="draft-prompt-continue-editing"
      >
        Continue Editing
      </Text>
    </Row>
  );
};
